import { z } from "zod";
import { normalizePhone } from "./phone.js";

// A phone number as typed; parsed to E.164 (invalid numbers fail with the message `phone`).
export const phoneSchema = z
  .string()
  .trim()
  .min(1)
  .max(40)
  .transform((value, ctx) => {
    const phone = normalizePhone(value);
    if (!phone) {
      ctx.addIssue({ code: "custom", message: "phone" });
      return z.NEVER;
    }
    return phone;
  });
